import {AdditionalProps} from 'modules/additionals/types';
import additionalsKeys from 'modules/additionals/util/additionals-keys';
import React from 'react';
import List from 'shared/layout/list';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';

const Additionals: React.FC = () => {
  const projection = useProjection<AdditionalProps>('additionals', [
    'id',
    'name',
    'description',
    'active',
    'additionalGroup.name',
    'price',
  ]);

  return (
    <List<AdditionalProps>
      {...{
        titleBar: {
          title: 'Adicionais',
          actionButton: {title: 'NOVO ADICIONAL', to: 'create'},
        },
        table: {
          url: '/additionals',
          projection: {
            ...projection,
            options: [
              'name',
              'description',
              'additionalGroup.name',
              {value: 'price', filter: {valueAsNumber: true}},
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      isChecked={row.active}
                      url={`/additionals/${row.id}`}
                      queryKey={additionalsKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
            ],
          },
          translatedPropsKey: 'AdditionalProps',
        },
        queryKey: additionalsKeys.list(),
      }}
    />
  );
};

export default Additionals;
